import { render, staticRenderFns } from "./MaterialListItem.vue?vue&type=template&id=38233fed&scoped=true"
import script from "./MaterialListItem.vue?vue&type=script&lang=ts"
export * from "./MaterialListItem.vue?vue&type=script&lang=ts"
import style0 from "./MaterialListItem.vue?vue&type=style&index=0&id=38233fed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38233fed",
  null
  
)

export default component.exports